// @flow
import React from 'react'

export default props => (
  <div className="container top-container">
    <div className="top-campaign__list">
      <div className="top-title__container clearfix">
        <h2 className="top-title">特集ピックアップ</h2>
        <a href="/topics" className="pc-hide__sm-show top-more__area-link">
          もっと見る
        </a>
      </div>
      <div className="top-units__container">
        <div className="row">
          {props.topics.map(
            (topic, index) =>
              // gqlのtopicsがpager持ってないので
              index < 3 && (
                <div key={topic.uid} className="col-xs-4 campaign-box">
                  <a href={`/topics/${topic.uid}`}>
                    <div className="campaign-linkbox is-hover">
                      <div className="md-top-units mdc-elevation--z2">
                        <img src={topic.image} alt={topic.title} />
                        <h3
                          className="campaign-subtitle"
                          style={{ backgroundColor: topic.themeColor }}
                        >
                          <span className="campaign-subtitle__name">
                            {topic.title}
                          </span>
                        </h3>
                      </div>
                    </div>
                  </a>
                </div>
              ),
          )}
        </div>
      </div>
    </div>
    <div className="sm-hide top-more__area">
      <a href="/topics" className="top-more__area-link">
        {i18n.t('page.home.label_000117')}
      </a>
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/organisms/TopicList/index.js